import { cn } from "@/lib/utils";
import { SearchHighlight } from "./SearchHighlight";
import {
  SEARCH_MATCH_FIELD_LABEL,
  SearchMatchField,
  type FreelancerSearchReason,
  type SearchTerm,
} from "./searchMatch";

/** E-mail e telefone a busca acha em qualquer ponto, não por palavra. */
const FIELDS_MATCHED_ANYWHERE = new Set([SearchMatchField.Email, SearchMatchField.Telefone]);

interface FreelancerSearchReasonsProps {
  reasons: FreelancerSearchReason[];
  term: SearchTerm;
  /** Termo como foi digitado, para os campos achados em qualquer ponto. */
  typedTerm: string;
  /** Campos com trecho; os demais aparecem só pelo nome. */
  maxSnippets: number;
  /** Linhas por trecho no card estreito; sem valor, o trecho aparece inteiro. */
  clampClassName?: string;
  className?: string;
}

/** Por que o perfil apareceu: trecho dos campos que batem com a busca e não estão à vista. */
export function FreelancerSearchReasons({
  reasons,
  term,
  typedTerm,
  maxSnippets,
  clampClassName,
  className,
}: FreelancerSearchReasonsProps) {
  if (reasons.length === 0) return null;

  const withSnippet = reasons.slice(0, maxSnippets);
  const nameOnly = reasons.slice(maxSnippets);

  return (
    <div className={cn("space-y-0.5 text-xs text-muted-foreground", className)} data-testid="busca-motivos">
      {withSnippet.map((reason) => (
        <p key={reason.field} className={clampClassName}>
          <span className="font-medium text-foreground">{SEARCH_MATCH_FIELD_LABEL[reason.field]}: </span>
          <SearchHighlight
            text={reason.snippet}
            term={FIELDS_MATCHED_ANYWHERE.has(reason.field) ? typedTerm : term}
          />
        </p>
      ))}
      {nameOnly.length > 0 && (
        <p>Também em: {nameOnly.map((reason) => SEARCH_MATCH_FIELD_LABEL[reason.field]).join(", ")}</p>
      )}
    </div>
  );
}
